import React, { FC } from "react";
import { Drawer } from "antd";

interface NavigationMenuIprops {
  visible: boolean;
  setVisible: (value: boolean) => void;
  children: any;
}

const NavigationMenu: FC<NavigationMenuIprops> = (props) => {
  const { children, visible, setVisible }: any = props;
  return (
    <Drawer
      placement="left"
      closable={true}
      onClose={() => setVisible(false)}
      visible={visible}
      key="navigationMenu"
      bodyStyle={{ background: children.props.isDark && "#001529" }}
      headerStyle={{ background: children.props.isDark && "#001529" }}
    >
      {children}
    </Drawer>
  );
};

export default NavigationMenu;
